<div class="row g-0" style="height: 600px;" >
  <div class=" col-md-3 gradient-custom text-center text-white"
       style="border-top-left-radius: .5rem; border-bottom-left-radius: .5rem; padding-top: 30px;">

    <img src="assets/img/institution.png" alt="institution" class="img-fluid mb-2 m-auto" style="width: 80px;" />
    <h4 class="mt-3 mb-2" style="font-weight: bold; padding: 0px 5px;">{{name}}</h4>
    <p class="mb-2">{{id}}
    <p class="mb-2">{{code}}
    <p class="mb-2">{{officeTel}}
    <p class="mb-2">{{email}}



    <ul class="nav nav-tabs modal-title mt-3" id="myTab0" role="tablist" (click)="onButtonGroupClick($event)">
      <button class=" row g-0 nav-link active side-bar-btn" id="general" data-mdb-toggle="tab"
              data-mdb-target="#home0" type="button" role="General" aria-label="General" aria-controls="home">
        <i class="custom-icon-button1" *ngIf="formControl['publicKey'].value === '-' || formControl['appKey'].value === '-' || formControl['appSecret'].value === '-' || (!openApiEnabled && !fixEnabled && !boApisEnabled && !dwmApiEnabled)"></i>
        <i class="custom-icon-button2" *ngIf="formControl['publicKey'].value !== '-' && formControl['appKey'].value !== '-' && formControl['appSecret'].value !== '-' && (openApiEnabled || fixEnabled || boApisEnabled || dwmApiEnabled)"></i>
        General
      </button>

      <button class=" row g-0 nav-link  side-bar-btn" id="masterAcc" data-mdb-toggle="tab"
              data-mdb-target="#profile0" type="button" role="Master Accounts" aria-label="Master Account"
              aria-controls="profile">
        <i class="custom-icon-button1" *ngIf="isNoCashAccounts|| isNoSecurityAccounts|| isNoExchangeAccounts"></i>
        <i class="custom-icon-button2" *ngIf="!isNoCashAccounts &&  !isNoSecurityAccounts && !isNoExchangeAccounts"></i>
        Master Accounts
      </button>
      <button class="row g-0 nav-link  side-bar-btn" id="exchanges" aria-label="Banks" data-mdb-toggle="tab"
              data-mdb-target="#contact0" type="button" role="Exchanges" aria-controls="contact"> <i class="custom-icon-button1" *ngIf="isTableEmptyExchange"></i><i class="custom-icon-button2" *ngIf="!isTableEmptyExchange"></i>
        Exchanges
      </button>
      <button class="row g-0 nav-link  side-bar-btn" id="banks" aria-label="Banks" data-mdb-toggle="tab"
              data-mdb-target="#contact0" type="button" role="Banks" aria-controls="contact"><i class="custom-icon-button3" *ngIf="isTableEmptyBank"></i><i class="custom-icon-button2" *ngIf="!isTableEmptyBank"></i>
        Banks
      </button>
      <button class="row g-0 nav-link  side-bar-btn" id="bankAcc" aria-label="Bank Accounts" data-mdb-toggle="tab"
              data-mdb-target="#contact0" type="button" role="Bank Accounts" aria-controls="contact"><i class="custom-icon-button3" *ngIf="isTableEmptyBankAcc"></i><i class="custom-icon-button2" *ngIf="!isTableEmptyBankAcc"></i>
        Bank Accounts
      </button>
      <button class="row g-0 nav-link side-bar-btn" id="customer" aria-label="Customer Profile"
              data-mdb-toggle="tab" data-mdb-target="#contact0" type="button" role="Customer Profiles"
              aria-controls="contact"><i class="custom-icon-button1" *ngIf="isTableEmptyProfile || noDefaultCustProfiles"></i><i class="custom-icon-button2" *ngIf="!isTableEmptyProfile && !noDefaultCustProfiles"></i>
        Customer Profile
      </button>
      <button class="row g-0 nav-link side-bar-btn" id="subscription" aria-label="Subscription Packages"
              data-mdb-toggle="tab" data-mdb-target="#contact0" type="button" role="Subscription Packages"
              aria-controls="contact"><i class="custom-icon-button1" *ngIf="isTableEmptyPackage || noDefaultSubsPckgs"></i><i class="custom-icon-button2" *ngIf="!isTableEmptyPackage && !noDefaultSubsPckgs"></i>
        Subscription Packages
      </button>
    </ul>
  </div>

  <div class="tab-content col-md-9" id="myTabContent0">
        <div class="modal-header">
          <div>
            <h2 style="font-weight: bold; font-size:larger; margin-left: 10px;" type="button">{{topic}}</h2>
          </div>
        </div>

    <div class="tab-pane fade show active key-container-content" id="" role="tabpanel"
         aria-labelledby="key-container">
      <div class="d-flex justify-content-center mt-4 mb-5">
        <div class="form content-card " id="col-id" #inst>
          <form class=" position-relative general-container"
                *ngIf="!isKeyEmpty; else emptyTableKey" [formGroup]="form" novalidate>
<!--            <div class="position-absolute top-50 start-50 translate-middle vstack"-->
<!--                 style="z-index: 1000">-->
<!--              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">-->
<!--                <span class="visually-hidden">Loading...</span>-->
<!--              </div>-->
<!--              <div class="loading-text">Loading...</div>-->
<!--            </div>-->
            <div>
              <label for="publicKey" class="form-label mb-2" style="font-weight: bold">General
                Details</label>
              <hr>
            </div>
            <div class="row mt-4">
              <div class="col-md-12 text-start">
                <label for="publicKey" class="form-label mb-2" style="font-weight: bold">Public
                  Key</label>

                <div class="alert" *ngIf="formControl['publicKey'].value === '-'">
                  <div>
                    <strong>Public key is missing</strong>
                  </div>
                </div>


                <textarea [readonly]="true" type="text" class="form-control" id="publicKey"
                          formControlName="publicKey" [ngClass]="{'red-highlight': formControl['publicKey'].value === '-'}"></textarea>

              </div>


            </div>

            <div class="row mt-4">
              <div class="col-md-6 text-start">
                <label for="appKey" class="form-label mb-2" style="font-weight: bold">App Key</label>

                <div class="alert" *ngIf="formControl['appKey'].value === '-'">
                  <div>
                    <strong>App key is missing</strong>
                  </div>
                </div>


                <input [readonly]="true" type="text" class="form-control" id="appKey"
                       formControlName="appKey" [ngClass]="{'red-highlight': formControl['appKey'].value === '-'}"/>

              </div>

              <div class="col-md-6 text-start">
                <label for="appSecret" class="form-label mb-2" style="font-weight: bold">App
                  Secret</label>

                <div class="alert" *ngIf="formControl['appSecret'].value === '-'">
                  <div>
                    <strong>App Secret is missing</strong>
                  </div>
                </div>
                <input [readonly]="true" type="text" class="form-control" id="appSecret"
                       formControlName="appSecret" [ngClass]="{'red-highlight': formControl['appSecret'].value === '-'}"/>

              </div>
            </div>
            <div class="d-flex mt-4 " [ngClass]="{'highlight-checkboxes':  !formControl['openApiEnabled'].value && !formControl['fixEnabled'].value && !formControl['boApisEnabled'].value && !formControl['dwmApiEnabled'].value}">
              <div class="alert" *ngIf="!formControl['openApiEnabled'].value && !formControl['fixEnabled'].value && !formControl['boApisEnabled'].value && !formControl['dwmApiEnabled'].value">
                <div>
                  <strong>At least one API should be enabled</strong>
                </div>
              </div>


              <div class="general-checkBox" >
                <input onclick="return false;"  type="checkbox" id="GtnApiEnableCheck" ng-model="check" formControlName="openApiEnabled"/>
                GTN API Enabled
              </div>
              <div class="general-checkBox" >
                <input onclick="return false;"  type="checkbox" id="FixApiEnableCheck" ng-model="check" formControlName="fixEnabled"/>
                FIX API Enabled
              </div>
              <div class="general-checkBox" >
                <input onclick="return false;"  type="checkbox" id="AccountApiEnableCheck" ng-model="check" formControlName="boApisEnabled"/>
                Backoffice API Enabled
              </div>
              <div class="general-checkBox" >
                <input onclick="return false;"  type="checkbox" id="DwmApiEnableCheck" ng-model="check" formControlName="dwmApiEnabled"/>
                DWM API Enabled
              </div>
            </div>


            <div class="d-flex mt-2">
              <div class="general-checkBox" >
                <input onclick="return false;"  type="checkbox" id="AutoWithrawEnableCheck" ng-model="check" formControlName="withdrawAutoApproval"/>
                Auto Withdraw Enabled
              </div>
              <div class="general-checkBox" >
                <input onclick="return false;"  type="checkbox" id="AutoDepositEnableCheck" ng-model="check" formControlName="depositAutoApproval"/>
                Auto Deposit Enabled
              </div>
            </div>
          </form>
        </div>


      </div>
    </div>
    <div class="tab-pane fade masterAcc-content" id="" role="tabpanel" aria-labelledby="masterAcc">
      <div class="d-flex justify-content-center mt-4 mb-5">
        <div #inst>
          <form class="form position-relative content-card" [ngClass]="loading ? 'blur-background' : ''"
                [formGroup]="form" novalidate id="collapse1">
            <div *ngIf="loading " class="position-absolute top-50 start-50 translate-middle vstack"
                 style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="row">
              <div class="col-md-12 text-start">
                <label for="publicKey" class="form-label" style="font-weight: bold">Master
                  Accounts</label>
                <div *ngIf="!isTableEmpty; else emptyTable">
                  <div class=" position-relative mt-5">
                    <div class="alert" *ngIf="isNoCashAccounts">
                      <div>
                        <strong>No cash accounts for the given master account</strong>
                      </div>
                    </div>


                    <li>
                      <label for="publicKey" class="form-label" style="font-weight: bold">Cash
                        Accounts</label>
                    </li>

                    <div class="table-container mt-3">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th scope="col">Cash A/C type</th>
                          <th scope="col">Cash A/C No</th>
                          <th scope="col">Currency</th>
                          <th scope="col">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let cash of customerDetails?.['cashAccounts']">
                          <td *ngIf="cash.accountType == 0">Current</td>
                          <td *ngIf="cash.accountType == 1">Savings</td>
                          <td *ngIf="cash.accountType == 2">Investment</td>
                          <td>{{cash.cashAccountNumber}}</td>
                          <td>{{cash.currency}}</td>
                          <td *ngIf="cash.status == 2">APPROVED</td>
                          <td *ngIf="cash.status == 5">DELETE</td>
                          <td *ngIf="cash.status != 2 && cash.status != 5">
                            UNKNOWN
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class=" position-relative mt-5">
                    <div class="alert" *ngIf="isNoSecurityAccounts">
                      <div>
                        <strong>No security accounts for the given master account</strong>
                      </div>
                    </div>
                    <li>

                      <label for="publicKey" class="form-label" style="font-weight: bold">Security
                        Accounts</label>
                    </li>

                    <div class="table-container mt-3">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th scope="col">Security A/C No</th>
                          <th scope="col">Account Type</th>
                          <th scope="col">Cash A/C No</th>
                          <th scope="col">Status</th>
                        </tr>
                        </thead>
                        <tbody *ngFor="let cash of customerDetails?.['cashAccounts']">
                        <tr *ngFor="let security of cash?.['securityAccounts']">
                          <td>{{security.accountNumber}}</td>
                          <!-- <td *ngIf="security.accountType == 0">Equity</td> -->
                          <td *ngIf="security.type == 1">Equity</td>
                          <td *ngIf="security.type == 2">Options</td>
                          <td *ngIf="security.type == 3">Futures</td>
                          <td *ngIf="security.type == 4">Forex</td>
                          <td *ngIf="security.type == 5">CFD</td>
                          <td *ngIf="security.type == 6">Spot</td>
                          <td *ngIf="security.type == 7">Auto Trade</td>
                          <td *ngIf="security.type == 8">Investment</td>
                          <td *ngIf="security.type == 10">crypto</td>
                          <td *ngIf="security.type == 11 ">
                            Investor Portfolio
                          </td>
                          <td>{{cash.cashAccountNumber}}</td>

                          <td *ngIf="security.statusId == 2">APPROVED</td>
                          <td *ngIf="security.statusId == 5">DELETE</td>
                          <td *ngIf="security.statusId != 2 && security.statusId != 5">
                            UNKNOWN
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class=" position-relative mt-5">
                    <div class="alert" *ngIf="isNoExchangeAccounts">
                      <div>
                        <strong>No exchange accounts for the given master account</strong>
                      </div>
                    </div>
                    <li>

                      <label for="publicKey" class="form-label" style="font-weight: bold">Trading
                        Accounts</label>
                    </li>

                    <div class="table-container mt-3">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th scope="col">Exchange</th>
                          <th scope="col">Trading Enable</th>
                          <th scope="col">Executing Broker</th>
                          <th scope="col">Status</th>
                          <th scope="col">Feed LEvel</th>
                        </tr>
                        </thead>
                        <ng-container *ngFor="let cash of customerDetails?.['cashAccounts']">
                          <tbody *ngFor="let security of cash?.['securityAccounts']">
                          <tr *ngFor="let exchange of security?.['exchangeAccounts']">
                            <td>{{exchange.exchange}}</td>

                            <td *ngIf="exchange.tradingEnabled == 1">Yes</td>
                            <td *ngIf="exchange.tradingEnabled == 0">No</td>
                            <td
                              *ngIf="exchange.tradingEnabled != 0 && exchange.tradingEnabled != 1 ">
                              null
                            </td>

                            <td *ngIf="exchange.executingBrokerId">
                              {{exchange.executingBrokerId}}
                            </td>
                            <td *ngIf="!exchange.executingBrokerId">null</td>

                            <td *ngIf="exchange.status == 3">APPROVED</td>
                            <td *ngIf="exchange.status == 6">DELETE</td>
                            <td *ngIf="exchange.status != 3 && exchange.status != 6">
                              UNKNOWN
                            </td>

                            <td *ngIf="exchange.feedLevel == 0">Delayed</td>
                            <td *ngIf="exchange.feedLevel == 1">
                              Delayed and L1
                            </td>
                            <td *ngIf="exchange.feedLevel == 2">
                              Delayed L1 and L2
                            </td>
                          </tr>
                          </tbody>
                        </ng-container>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="tab-pane fade exchange-content" id="exchange" role="tabpanel">
      <div class="d-flex justify-content-center mb-5" style="padding-bottom: 0px; margin-top: 30px">
        <div class="" #inst>
          <form class=" collapse2 content-card form position-relative "
                [ngClass]="loadingExchanges ? 'blur-background' : ''" [formGroup]="form" novalidate>
            <div *ngIf="loadingExchanges " class="position-absolute top-50 start-50 translate-middle vstack"
                 style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="row">

              <div class="alert" *ngIf="isTableEmptyExchange">
                <div>
                  <strong>No Exchanges for the given institution</strong>
                </div>
              </div>


              <div class="col-md-12 text-start">
                <label for="publicKey" class="form-label" style="font-weight: bold">Assigned Exchanges</label>

                <div *ngIf="!isTableEmptyExchange; else emptyTable">
                  <div class=" position-relative ">
                    <div class="table-container">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th scope="col">Exchange Code</th>
                          <th scope="col">Description</th>
                          <th scope="col">Pre Open</th>
                          <th scope="col">Open</th>
                          <th scope="col">Pre Close</th>
                          <th scope="col">Close</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr *ngFor="let exchange of Exchanges?.['list']">
                          <td *ngIf="exchange.exchangeCode">{{exchange.exchangeCode}}</td>
                          <td *ngIf="!exchange.exchangeCode">-</td>
                          <td *ngIf="exchange.description">{{exchange.description}}</td>
                          <td *ngIf="!exchange.description">-</td>
                          <td *ngIf="exchange.preOpen">{{exchange.preOpen}}</td>
                          <td *ngIf="!exchange.preOpen">-</td>
                          <td *ngIf="exchange.open">{{exchange.open}}</td>
                          <td *ngIf="!exchange.open">-</td>
                          <td *ngIf="exchange.preClose">{{exchange.preClose}}</td>
                          <td *ngIf="!exchange.preClose">-</td>
                          <td *ngIf="exchange.close">{{exchange.close}}</td>
                          <td *ngIf="!exchange.close">-</td>


                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="tab-pane fade bank-content" id="bank" role="tabpanel">
      <div class="d-flex justify-content-center mb-5" style="padding-bottom: 0px; margin-top: 30px">
        <div class="" #inst>
          <form class=" collapse2 content-card form position-relative "
                [ngClass]="loadingBank ? 'blur-background' : ''" [formGroup]="form" novalidate>
            <div *ngIf="loadingBank " class="position-absolute top-50 start-50 translate-middle vstack"
                 style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="row">
              <div class="col-md-12 text-start">
                <div class="alert warning" *ngIf="isTableEmptyBank">
                  <div>
                    <strong>No Banks for the given institution</strong>
                  </div>
                </div>



                <label for="publicKey" class="form-label" style="font-weight: bold">Banks</label>
                <div *ngIf="!isTableEmptyBank; else emptyTable">
                  <div class=" position-relative ">
                    <div class="table-container">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th scope="col">Bank Name</th>
                          <th scope="col">Swift Code</th>
                          <th scope="col">Tel</th>
                          <th scope="col">Status</th>
                          <th scope="col">Online Trading</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr *ngFor="let bank of instBankList?.['bankList']">
                          <td *ngIf="bank.bankName">{{bank.bankName}}</td>
                          <td *ngIf="!bank.bankName">-</td>
                          <td *ngIf="bank.swiftCode">{{bank.swiftCode}}</td>
                          <td *ngIf="!bank.swiftCode">-</td>
                          <td *ngIf="bank.telephoneNo">{{bank.telephoneNo}}</td>
                          <td *ngIf="!bank.telephoneNo">-</td>

                          <td *ngIf="bank.bankStatus">{{bank.bankStatus}}</td>
                          <td *ngIf="!bank.bankStatus">-</td>

                          <td *ngIf="bank.onlineTrading">{{bank.onlineTrading}}</td>
                          <td *ngIf="!bank.onlineTrading">-</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="tab-pane fade bankAcc-content" id="" role="tabpanel" aria-labelledby="bankAcc">
      <div class="d-flex justify-content-center mb-5" style="padding-bottom: 0px; margin-top: 30px">
        <div  #inst>
          <form class="collapse2 content-card form position-relative "
                [ngClass]="loadingBankAcc ? 'blur-background' : ''" [formGroup]="form" novalidate>
            <div *ngIf="loadingBankAcc " class="position-absolute top-50 start-50 translate-middle vstack"
                 style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="row">
              <div class="col-md-12 text-start">

                <div class="alert warning" *ngIf="isTableEmptyBankAcc">
                  <div>
                    <strong>No Bank accounts for the given institution</strong>
                  </div>
                </div>

                <label for="publicKey" class="form-label" style="font-weight: bold">Bank
                  Accounts</label>
                <div *ngIf="!isTableEmptyBankAcc; else emptyTable">
                  <div class=" position-relative mt-3">
                    <div class="table-container">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th scope="col">Account Number</th>
                          <th scope="col">Bank Name</th>
                          <th scope="col">Currency</th>
                          <th scope="col">Balance in Bank</th>
                          <th scope="col">Is Default</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr *ngFor="let bankAcc of bankDetails?.['bankAccountList']">
                          <td *ngIf="bankAcc.bankAccountNumber">{{bankAcc.bankAccountNumber}}</td>
                          <td *ngIf="!bankAcc.bankAccountNumber">-</td>
                          <td *ngIf="bankAcc.bankName">{{bankAcc.bankName}}</td>
                          <td *ngIf="!bankAcc.bankName">-</td>
                          <td *ngIf="bankAcc.currency">{{bankAcc.currency}}</td>
                          <td *ngIf="!bankAcc.currency">-</td>
                          <td *ngIf="bankAcc.balance">{{bankAcc.balance}}</td>
                          <td *ngIf="!bankAcc.balance">0</td>
                          <td *ngIf="bankAcc.isDefault">{{bankAcc.isDefault}}</td>
                          <td *ngIf="!bankAcc.isDefault">-</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="tab-pane fade customer-content " id="customer" role="tabpanel">
      <div class="d-flex justify-content-center " style="padding: 10px 0px; ">
        <div class="" #inst>
          <form class="content-card form position-relative content-card-devide"
                [ngClass]="loadingCustomerProfile ? 'blur-background' : ''" [formGroup]="form" novalidate>
            <div *ngIf="loadingCustomerProfile "
                 class="position-absolute top-50 start-50 translate-middle vstack" style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="row">

              <div class="col-md-12 text-start">

                <div class="alert" *ngIf="isTableEmptyProfile">
                  <div>
                    <strong>No Customer Profiles for the given institution</strong>
                  </div>
                </div>

                <div class="alert" *ngIf="!isTableEmptyProfile && noDefaultCustProfiles">
                  <div>
                    <strong>No Default Customer Profile for the given institution</strong>
                  </div>
                </div>
                <label for="publicKey" class="form-label"
                       style="font-weight: bold; margin-top: 5px;">Customer Profiles</label>
                <div *ngIf="!isTableEmptyProfile; else emptyTable">
                  <div class=" position-relative mt-2">
                    <div class="table-container">
                      <table class="table table-hover table-cp">
                        <thead>
                        <tr>
                          <th scope="col">Profile Number</th>
                          <th scope="col">Profile Name</th>
                          <th scope="col">Profile Description</th>
                          <th scope="col">Status</th>
                          <th scope="col">Is Default</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr (click)="selectedRowCP($event,cusProfile.profileNumber,userInded,cusProfile.profileName)"
                            *ngFor="let cusProfile of instCustomerProfile?.['profileList']; let userInded = index"
                            [ngClass]="userInded ==  selectedUserIndex ? 'selRow' : ''">
                          <td *ngIf="cusProfile.profileNumber">
                            {{cusProfile.profileNumber}}</td>
                          <td *ngIf="!cusProfile.profileNumber">-</td>
                          <td *ngIf="cusProfile.profileName">{{cusProfile.profileName}}
                          </td>
                          <td *ngIf="!cusProfile.profileName">-</td>
                          <td *ngIf="cusProfile.description">{{cusProfile.description}}
                          </td>
                          <td *ngIf="!cusProfile.description">-</td>

                          <td *ngIf="cusProfile.status">{{cusProfile.status}}</td>
                          <td *ngIf="!cusProfile.status">-</td>

                          <td *ngIf="cusProfile.isDefault">{{cusProfile.isDefault}}</td>
                          <td *ngIf="!cusProfile.isDefault">-</td>

                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <hr>
      <div class="table-content-down mt-3">
        <div role="tabpanel">
          <div class="d-flex justify-content-center mt-1 ">
            <div #inst>
              <form class="content-card form position-relative  content-card-devide-down" [formGroup]="form" novalidate
                    [ngClass]="loadingCP ? 'blur-background' : ''">
                <div *ngIf="loadingCP " class="position-absolute top-50 start-50 translate-middle vstack"
                     style="z-index: 1000">
                  <div class="spinner-border text-primary" style="width: 3rem; height: 3rem"
                       role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div class="loading-text">Loading...</div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-start">
                    <div *ngIf="isSelectRowCP; else selectRow">
                      <label class="form-label" style="font-weight: bold">Master
                        Accounts relevant to {{customerName}}</label>
                      <div *ngIf="!isTableEmptyCP; else emptyTableCP" style="font-size: small;">
                        <div class=" position-relative mt-2">
                          <li>
                            <label class="form-label" style="font-weight: bold">Cash
                              Accounts</label>
                          </li>
                          <div class="table-container mt-1">
                            <table class="table table-sm"
                                   *ngFor="let cash of customerDetailsCP?.['cashAccounts']">
                              <thead>
                              <tr>
                                <th scope="col">Cash A/C type</th>
                                <th scope="col">Cash A/C No</th>
                                <th scope="col">Currency</th>
                                <th scope="col">Status</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr>
                                <td *ngIf="cash.accountType == 0">Current</td>
                                <td *ngIf="cash.accountType == 1">Savings</td>
                                <td *ngIf="cash.accountType == 2">Investment</td>
                                <td>{{cash.cashAccountNumber}}</td>
                                <td>{{cash.currency}}</td>
                                <td *ngIf="cash.status == 2">APPROVED</td>
                                <td *ngIf="cash.status == 5">DELETE</td>
                                <td *ngIf="cash.status != 2 && cash.status != 5">
                                  UNKNOWN
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class=" position-relative mt-1">
                          <li>
                            <label for="publicKey" class="form-label"
                                   style="font-weight: bold">Security
                              Accounts</label>
                          </li>

                          <div class="table-container mt-1" *ngFor="let cash of customerDetailsCP?.['cashAccounts']">
                            <table class="table table-sm" *ngFor="let security of cash?.['securityAccounts']">
                              <thead>
                              <tr>
                                <th scope="col">Security A/C No</th>
                                <th scope="col">Account Type</th>
                                <th scope="col">Cash A/C No</th>
                                <th scope="col">Status</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr >
                                <td>{{security.accountNumber}}</td>
                                <td *ngIf="security.type == 1">Equity</td>
                                <td *ngIf="security.type == 2">Options</td>
                                <td *ngIf="security.type == 3">Futures</td>
                                <td *ngIf="security.type == 4">Forex</td>
                                <td *ngIf="security.type == 5">CFD</td>
                                <td *ngIf="security.type == 6">Spot</td>
                                <td *ngIf="security.type == 7">Auto Trade
                                </td>
                                <td *ngIf="security.type == 8">Investment
                                </td>
                                <td *ngIf="security.type == 10">crypto</td>
                                <td *ngIf="security.type == 11 ">
                                  Investor Portfolio
                                </td>
                                <td>{{cash.cashAccountNumber}}</td>

                                <td *ngIf="security.statusId == 2">APPROVED</td>
                                <td *ngIf="security.statusId == 5">DELETE</td>
                                <td
                                  *ngIf="security.statusId != 2 && security.statusId != 5">
                                  UNKNOWN
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class=" position-relative mt-1">
                          <li>
                            <label for="publicKey" class="form-label"
                                   style="font-weight: bold">Trading
                              Accounts</label>
                          </li>

                          <div class="table-container mt-1"
                               *ngFor="let cash of customerDetailsCP?.['cashAccounts']">
                            <table class="table table-sm"
                                   *ngFor="let security of cash?.['securityAccounts']">
                              <ng-container  *ngFor="let exchange of security?.['exchangeAccounts']">
                                <thead >
                                <tr>
                                  <th scope="col">Exchange</th>
                                  <th scope="col">Trading Enable</th>
                                  <th scope="col">Executing Broker</th>
                                  <th scope="col">Status</th>
                                  <th scope="col">Feed Level</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr >
                                  <td>{{exchange.exchange}}</td>

                                  <td *ngIf="exchange.tradingEnabled == 1">Yes
                                  </td>
                                  <td *ngIf="exchange.tradingEnabled == 0">No</td>
                                  <td
                                    *ngIf="exchange.tradingEnabled != 0 && exchange.tradingEnabled != 1 ">
                                    nullddd
                                  </td>

                                  <td *ngIf="exchange.executingBrokerId">
                                    {{exchange.executingBrokerId}}
                                  </td>
                                  <td *ngIf="!exchange.executingBrokerId">null
                                  </td>

                                  <td *ngIf="exchange.status == 3">APPROVED</td>
                                  <td *ngIf="exchange.status == 6">DELETE</td>
                                  <td
                                    *ngIf="exchange.status != 3 && exchange.status != 6">
                                    UNKNOWN
                                  </td>

                                  <td *ngIf="exchange.feedLevel == 0">Delayed</td>
                                  <td *ngIf="exchange.feedLevel == 1">
                                    Delayed and L1
                                  </td>
                                  <td *ngIf="exchange.feedLevel == 2">
                                    Delayed L1 and L2
                                  </td>
                                </tr>
                                </tbody>
                              </ng-container>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-pane fade subscription-content " id="subscription" role="tabpanel">
      <div class="d-flex justify-content-center " style="padding: 10px 0px; ">
        <div class="" #inst>
          <form class="content-card form position-relative content-card-devide"
                [ngClass]="loadingSubscriptionPackage ? 'blur-background' : ''" [formGroup]="form" novalidate>
            <div *ngIf="loadingSubscriptionPackage " class="position-absolute top-50 start-50 translate-middle vstack"
                 style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="row">
              <div class="col-md-12 text-start">



                <div class="alert" *ngIf="isTableEmptyPackage">
                  <div>
                    <strong>No Subscription Package for the given institution</strong>
                  </div>
                </div>

                <div class="alert" *ngIf="!isTableEmptyPackage && noDefaultSubsPckgs">
                  <div>
                    <strong>No Default Subscription Package for the given institution</strong>
                  </div>
                </div>






                <label for="publicKey" class="form-label"
                       style="font-weight: bold; margin-top: 5px;">Subscription Packages</label>
                <div *ngIf="!isTableEmptyPackage; else emptyTable">
                  <div class=" position-relative mt-2">
                    <div class="table-container">
                      <table class="table table-hover table-cp">
                        <thead>
                        <tr style="background-color: rgba(0, 0, 0, 0.082);">
                          <th scope="col">Package ID</th>
                          <th scope="col">Package Name</th>
                          <th scope="col">Package Description</th>
                          <th scope="col">Status</th>
                          <th scope="col">IS Default</th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr (click)="selectedRowSP($event,subsPackage,userIndedSP)"
                            *ngFor="let subsPackage of instSubscriptionPackages?.['packageList']; let userIndedSP = index"
                            [ngClass]="userIndedSP ==  selectedUserIndexSP ? 'selRow' : ''">
                          <td *ngIf="subsPackage.packageId">{{subsPackage.packageId}}</td>
                          <td *ngIf="!subsPackage.packageId">-</td>
                          <td *ngIf="subsPackage.packageName">{{subsPackage.packageName}}
                          </td>
                          <td *ngIf="!subsPackage.packageName">-</td>
                          <td *ngIf="subsPackage.packageDescription">{{subsPackage.packageDescription}}
                          </td>
                          <td *ngIf="!subsPackage.packageDescription">-</td>

                          <td *ngIf="subsPackage.status">{{subsPackage.status}}
                          </td>
                          <td *ngIf="!subsPackage.status">-</td>

                          <td *ngIf="subsPackage.isDefault">{{subsPackage.isDefault}}
                          </td>
                          <td *ngIf="!subsPackage.isDefault">-</td>


                        </tr>
                        </tbody>
                      </table>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <hr>
      <div class="table-content-down mt-3">
        <div class="" role="tabpanel">
          <div class="d-flex justify-content-center mt-2 ">
            <div #inst>
              <form class="content-card form position-relative content-card-devide-down" [formGroup]="form" novalidate >
                <div *ngIf="loadingBank "
                     class="position-absolute top-50 start-50 translate-middle vstack"
                     style="z-index: 1000">
                  <div class="spinner-border text-primary" style="width: 3rem; height: 3rem"
                       role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <div class="loading-text">Loading...</div>
                </div>
                <div class="row">
                  <div *ngIf="isSelectRowSP; else selectRowSP" class="col-md-12 text-start">
                    <label for="publicKey" class="form-label"
                           style="font-weight: bold; margin-top: 5px;">Assigned Exchanges relavant to {{packageName}}</label>
                    <div *ngIf="!isTableEmpty; else emptyTableSP">
                      <div class=" position-relative mt-3">
                        <div class="table-container">
                          <table class="table table-sm" style="font-size: small;">
                            <thead>
                            <tr>
                              <th scope="col">Exchange</th>
                              <th scope="col">Feed Level</th>
                              <th scope="col">Currency</th>
                            </tr>
                            </thead>

                            <tbody>
                            <tr *ngFor="let subExchange of subsPackages?.['exchangeList']">
                              <td *ngIf="subExchange.exchange">{{subExchange.exchange}}</td>
                              <td *ngIf="!subExchange.exchange">-</td>
                              <td *ngIf="subExchange.feedLevel">{{subExchange.feedLevel}}</td>
                              <td *ngIf="subExchange.feedLevel == '' || subExchange.feedLevel == null " >-</td>
                              <td *ngIf="subExchange.currency">{{subExchange.currency}}</td>
                              <td *ngIf="!subExchange.currency">-</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyTableKey class="d-flex mt-5 mb-5">
  <div class="d-flex justify-content-center mt-5 mb-5" style="min-width: 750px;">
    <div class="form-label">
      <img src="assets/img/empty_data_icon.png" alt="empty data icon"
           style="width: 200px; height: 150px; margin-left: 30px" />
      <h1 class="nodata-message">No Public key, App key and App secret</h1>
    </div>
  </div>
</ng-template>
<ng-template #emptyTable class="d-flex mt-5 mb-5">
  <div class="d-flex justify-content-center mt-5 mb-5" style="min-width: 750px;">
    <div class="form-label">
      <img src="assets/img/empty_data_icon.png" alt="empty data icon"
           style="width: 200px; height: 150px; margin-left: 30px" />
      <h1 class="nodata-message">No {{topic}} to relavant Institution</h1>
    </div>
  </div>
</ng-template>
<ng-template #emptyTableCP class="d-flex mt-5 mb-5">
  <div class="d-flex justify-content-center mt-5 mb-5" style="min-width: 750px;">
    <div class="form-label">
      <img src="assets/img/empty_data_icon.png" alt="empty data icon"
           style="width: 100px; height: 75px; margin-left: 140px" />
      <h1 class="nodata-message">No Master Accounts to relavant Customer Profile</h1>
    </div>
  </div>
</ng-template>



<ng-template #emptyTableSP class="d-flex mt-5 mb-5">
  <div class="d-flex justify-content-center mt-5 mb-5" style="min-width: 750px;">
    <div class="form-label">
      <img src="assets/img/empty_data_icon.png" alt="empty data icon"
           style="width: 100px; height: 75px; margin-left: 140px" />
      <h1 class="nodata-message">No assigned Exchanges to relavant customer profile</h1>
    </div>
  </div>
</ng-template>
<ng-template #selectRow class="d-flex mt-5 mb-5">
  <div class="d-flex justify-content-center mt-5 mb-5" style="min-width: 750px; min-height: 240px;">
    <div class="form-label">
      <h1 class="nodata-message">Select a Customer Profile to view relavant master accounts</h1>
    </div>
  </div>
</ng-template>
<ng-template #selectRowSP class="d-flex mt-5 mb-5">
  <div class="d-flex justify-content-center mt-5 mb-5" style="min-width: 750px; min-height: 240px;">
    <div class="form-label">
      <h1 class="nodata-message">Select a Subscription package to view exchanges</h1>
    </div>
  </div>
</ng-template>
